import React from "react";

const NotFound = () => {
	return <div className="notFound">404 | Not Found</div>;
};

export default NotFound;
